












import { Icon } from '../basic';

export default {
  name: 'EmptyState',
  props: {
    title: String,
    description: String,
    iconName: {
      type: String,
      default: 'btn-add-primary',
    },
    iconSize: {
      type: Number,
      default: 24,
    },
  },
  components: {
    Icon,
  },
};
